import * as React from 'react';
import { Component } from 'react';
import { FormGroup, Label, Input, Col, Tooltip } from 'reactstrap';

class DropdownWithDataSourceFieldComponent extends Component {
    constructor(props) {
        super(props);

        this.formElementRef = null;

        var optionGrupsMap =
            this.props.field.listValues && this.props.field.listValues[0].groupText ?
                this.props.field.listValues.reduce((optionsSoFar, { value, text, groupText }) => {
                    if (!optionsSoFar[groupText]) optionsSoFar[groupText] = [];
                    optionsSoFar[groupText].push({ value: value, text: text, groupText: groupText });
                    return optionsSoFar;
                }, {}) : undefined;

        var optionGrups = undefined;
        if (optionGrupsMap) {
            optionGrups = [];
            for (var o in optionGrupsMap) {
                optionGrups.push({ groupText: o, options: optionGrupsMap[o] });
            }
            optionGrups = optionGrups.sort((a, b) => a.groupText.localeCompare(b.groupText));
        }
       

        this.state = {
            model: this.props.model,
            optionGrups: optionGrups,
            tooltip: false
        }
    }

    getInputElement() {
        return this.formElementRef;
    }

    isEmptyAndRequired(inputElement, inputModel) {
        if ((!inputElement.value || inputElement.value === "") && !inputModel.allowEmpty) {
            return true;
        }
        return false;
    }

    inputChange(event) {
        let inputElement = event.target;
        var columnModel = this.state.model;
        if (columnModel) {
            if (this.isEmptyAndRequired(inputElement, columnModel)) {
                columnModel.invalid = true;
            }
            else {
                var notSatisfiedObject = columnModel.isNotValid();
                columnModel.invalid = false || notSatisfiedObject.notSatisfied;
                columnModel.value = inputElement.value;
                if (columnModel.invalid) {
                    columnModel.errorMessage = notSatisfiedObject.message;
                }
                else {
                    columnModel.errorMessage = "";
                }
            }

            this.setState({ model: columnModel }, () => {
                this.props.onChanged && this.props.onChanged();
            });
        }
    }

    toggleTooltip() {
        var tempModel = this.state.tooltip;

        if (this.state.model.errorMessage && this.state.model.errorMessage != "") {
            tempModel = !tempModel;
            this.setState({
                tooltip: tempModel
            });
        }
    }

    render() {
        return (
            <FormGroup row key={this.props.field.guid} className={this.props.labelOnTop && this.props.field.caption && this.props.field.caption !== "" ? "label-top" : ""}
                style={this.state.model.visible ? {} : { display: 'none' }}>
                <Col sm={3} style={this.props.showLabel && !this.props.labelOnTop ? {} : { display: 'none' }}>
                    <Label for={"dwnWithDataSource" + this.props.field.column + "_" + this.props.field.guid} className="input-label">
                        {this.props.field.caption}
                        <span className="required" style={!this.props.field.allowEmpty && this.props.field.caption && this.props.field.caption !== "" ? {} : { display: 'none' }}> *</span>
                    </Label>
                </Col>
                <Col sm={!this.props.showLabel || this.props.labelOnTop ? 12 : 9}>
                    <Label for={"dwnWithDataSource" + this.props.field.column + "_" + this.props.field.guid}
                        style={this.props.labelOnTop && this.props.field.caption && this.props.field.caption !== "" ? {} : { display: 'none' }}
                        className="input-label">
                        {this.props.field.caption}
                        <span className="required" style={!this.props.field.allowEmpty && this.props.field.caption && this.props.field.caption !== "" ? {} : { display: 'none' }}> *</span>
                    </Label>
                    <Input invalid={this.state.model.invalid}
                        type="select" name={this.props.field.column}
                        id={"dwnWithDataSource" + this.props.field.column + "_" + this.props.field.guid} placeholder={this.props.field.caption}
                        onChange={this.inputChange.bind(this)}
                        innerRef={ref => { this.formElementRef = ref; this.props.formElementRefs[this.props.field.column] = ref }}
                        defaultValue={this.state.model.value}>
                        {
                            (this.state.optionGrups || "").length && this.state.optionGrups.map((optiongroup) => {
                                return <optgroup key={optiongroup.groupText} label={optiongroup.groupText}>
                                    {optiongroup.options.map((option) => {
                                        return <option key={option.value} value={option.value}>{option.text}</option>
                                    })}
                                </optgroup>
                            })
                            ||
                            this.props.field.listValues.map((option) => {
                                return <option key={option.value} value={option.value}>{option.text} {option.groupText}</option>
                            })
                        }
                    </Input>
                    <div className="explanation-text">{this.props.field.explanationText}</div>
                    <div id={this.props.field.column + "_errorMessage_" + this.props.field.guid} style={this.state.model.invalid ? {} : { display: 'none' }}
                        className="invalid-message">
                        <Tooltip placement="top"
                            target={this.props.field.column + "_errorMessage_" + this.props.field.guid}
                            toggle={this.toggleTooltip.bind(this)}
                            isOpen={this.state.tooltip}>
                            {this.state.model.errorMessage}
                        </Tooltip>
                    </div>
                </Col>
            </FormGroup>
        )
    }
}

export default DropdownWithDataSourceFieldComponent;